import request from 'axios';
import { browserHistory } from 'react-router';
import { setBannerError } from 'error';
import { createAction, handleActions } from 'redux-actions';

/** ****************************************************************
 * Constants *******************************************************
 * ****************************************************************
 */
export const STAGE_VOTE = 'vote';
export const STAGE_DONE = 'done';

export const SET_STAGE = 'crowdspring/focusgroups/SET_VOTING_STAGE';

export const TOGGLE_VOTING = 'crowdspring/focusgroups/TOGGLE_VOTING';
export const PREVIOUS_VOTING = 'crowdspring/focusgroups/PREVIOUS_VOTING';
export const NEXT_VOTING = 'crowdspring/focusgroups/NEXT_VOTING';

export const TOGGLE_CONFIRM_VOTE = 'crowdspring/focusgroups/TOGGLE_CONFIRM_VOTE';

export const REQ_VOTE = 'crowdspring/focusgroups/REQ_VOTE';
export const REC_VOTE = 'crowdspring/focusgroups/REC_VOTE';

export const SET_RATING = 'crowdspring/focusgroups/SET_RATING';
export const SET_COMMENT = 'crowdspring/focusgroups/SET_COMMENT';
export const SET_VOTE_INDEX = 'crowdspring/focusgroups/SET_VOTE_INDEX';

/** ****************************************************************
 * Action Creators *******************************************************
 * ****************************************************************
 */
export const setStage = createAction(SET_STAGE);

export const reqVote = createAction(REQ_VOTE);
export const recVote = createAction(REC_VOTE);

export const toggleVoting = createAction(TOGGLE_VOTING);
export const previous = createAction(PREVIOUS_VOTING);
export const setRating = createAction(SET_RATING);
export const setComment = createAction(SET_COMMENT);
export const setVoteIndex = createAction(SET_VOTE_INDEX);

export const toggleConfirmVote = createAction(TOGGLE_CONFIRM_VOTE);

export const vote = (key, groupId, id, data, type = 'image') => (dispatch) => {
  dispatch(reqVote());
  const config = { headers: { 'X-Participant-Key': key } };
  const url = `/api/v1/focus-groups/${groupId}/${type}-revisions/${id}/vote/`;
  const promise = request.post(url, data, config);

  promise.then(() => {
    dispatch(recVote());
  }).catch(() => (
    dispatch(setBannerError(
      'Focus Group Error',
      'There was an error voting on this focus group, please try again later.'
    ))
  ));

  return promise;
};

export const identifyAnonymousUser = (groupId, anonymousKey) => (dispatch, getState) => {
  const searchParams = getState().routing.locationBeforeTransitions.search;
  const config = { headers: { 'X-Anonymous-Key': anonymousKey } };
  const url = `/api/v1/focus-groups/${groupId}/participants/identify/`;
  /* redirect user to vote page as the newly-created participant */
  return request.patch(url, {}, config).then(({ data }) => {
    browserHistory.replace(
      `/focus-group-participate/${groupId}/${data.id}/${data.key}/${searchParams}`
    );
  }).catch(() => (
    dispatch(setBannerError(
      'Focus Group Error',
      'There was an error identifying this user, please try again later.'
    ))
  ));
}

export const setParticipantInfo = (groupId, participantId, key, data) => (dispatch) => {
  const config = { headers: { 'X-Participant-Key': key } };
  const url = `/api/v1/focus-groups/${groupId}/participants/${participantId}/set_info/`;
  return request.patch(url, data, config);
}


/** ****************************************************************
 * Initial State *******************************************************
 * ****************************************************************
 */
export const initialState = {
  stage: STAGE_VOTE,
  isVoting: false,
  isSending: false,
  isConfirmingVote: false,
  currentRevisionIndex: null,
  currentComment: null,
  currentRating: null,
};

/** ****************************************************************
 * Reducer *******************************************************
 * ****************************************************************
 */
const votingReducer = handleActions({
  [setStage]: (state, action) => ({
    ...state,
    stage: action.payload
  }),
  [toggleVoting]: state => ({
    ...state,
    isVoting: !state.isVoting,
    currentRevisionIndex: state.currentRevisionIndex ? null : 0,
  }),
  [toggleConfirmVote]: state => ({
    ...state,
    isConfirmingVote: !state.isConfirmingVote,
  }),
  [setVoteIndex]: (state, action) => ({
    ...state,
    currentComment: null,
    currentRating: null,
    currentRevisionIndex: action.payload,
  }),
  [previous]: state => ({
    ...state,
    currentRevisionIndex: state.currentRevisionIndex === 0 ? 0 : state.currentRevisionIndex - 1,
    currentComment: null,
    currentRating: null
  }),
  [reqVote]: state => ({
    ...state,
    isSending: true,
    currentRating: null,
  }),
  [recVote]: (state, action) => ({
    ...state,
    isSending: false,
  }),
  [setRating]: (state, action) => ({
    ...state,
    currentRating: action.payload,
  }),
  [setComment]: (state, action) => ({
    ...state,
    currentComment: action.payload,
  }),
}, initialState);

export default votingReducer;
